import { SxProps } from '@mui/material'
import { scaledPx } from '@/styles'
import { brandMarkHeight, iconSlot, lockupMarkInset, sidebarClasses } from '../SidebarLayout.data'
import { sidebarGutter } from '../SidebarLayout.style'

interface SidebarBrandStyles {
  row: SxProps
  slot: SxProps
  slotToggle: SxProps
  mark: SxProps
  lockupSlot: SxProps
  lockup: SxProps
  toggleGlyph: SxProps
  collapseButton: SxProps
}

export const sidebarBrandStyles: SidebarBrandStyles = {
  row: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    px: sidebarGutter,
    pt: 1.5,
    pb: 1,
  },
  // The mark sits in the same slot at the same size in every state, so it reads
  // as one logo that stays put rather than two that trade places.
  slot: {
    position: 'relative',
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: scaledPx(iconSlot),
    height: scaledPx(iconSlot),
    borderRadius: 999,
  },
  // Collapsed, the slot is the expand control: hovering trades the mark for a
  // chevron in place, so the rail needs no second target for it.
  slotToggle: {
    transition: 'background .2s',
    '&:hover, &:focus-visible': {
      backgroundColor: 'utils.gray50',
      [`.${sidebarClasses.brandMark}`]: { opacity: 0 },
      [`.${sidebarClasses.brandToggle}`]: { opacity: 1 },
    },
  },
  mark: {
    // Never shrinks: inside a flex slot narrower than itself an SVG would
    // otherwise be squeezed and scaled down to fit.
    flexShrink: 0,
    height: scaledPx(brandMarkHeight),
    width: 'auto',
    display: 'block',
    transition: 'opacity .15s',
  },
  // Carries the icon slot's height so the row measures the same either way —
  // without it the shorter collapse button sets the height and the mark drifts
  // 2px up. Offset so the lockup's own embedded mark lands where the rail centres
  // the standalone one.
  lockupSlot: {
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    height: scaledPx(iconSlot),
    ml: `${lockupMarkInset}px`,
  },
  lockup: {
    flexShrink: 0,
    height: scaledPx(brandMarkHeight),
    width: 'auto',
    display: 'block',
  },
  toggleGlyph: {
    position: 'absolute',
    width: scaledPx(20),
    height: scaledPx(20),
    color: 'text.tertiary600',
    opacity: 0,
    transition: 'opacity .15s',
  },
  collapseButton: {
    ml: 'auto',
  },
}
